import moment from "moment";

function formatTimestamp(date, type = "large") {
  try {
    if (!date) return "";
    if (type === "unix") return moment.unix(date).format("DD/MM/YYYY");
    if (type === "date_z") return moment(date).utc().format("DD/MM/YYYY");

    let date_formated = new Date(date._seconds ? date._seconds * 1000 : date);
    let to_date = date_formated.getTime() ? date_formated : date.toDate();

    if (type === "format_DD/MM/YYYY") return moment(to_date).format("DD/MM/YYYY");
    if (type === "format_DD/MM/YYYY_hh:mm_a") return moment(to_date).format("DD/MM/YYYY hh:mm a");
    if (type === "only_date") return moment(to_date).format("YYYY-MM-DD");
    if (type === "only_time") return moment(to_date).format("hh:mm a");
    if (type === "only_year_month") return moment(to_date).format("YYYY-MM");

    let days_before = moment().diff(to_date, "days");

    if (days_before < 1) return moment(to_date).fromNow();
    else {
      if (type === "large") return moment(to_date).format("ddd DD MMM YYYY hh:mm a");
      if (type == "short") return moment(to_date).format("ddd DD MMM");
      return moment(to_date).format("DD/MM/YYYY hh:mm a");
    }
  } catch (error) {
    return "-";
  }
}

export default formatTimestamp;
